import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) { setError(formatApiError(err)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <img src="/logo-full.png" alt="Home Haven" className="h-28 w-auto" />
        <div className="text-[10px] uppercase tracking-[0.28em] text-stone mt-6 mb-12">Area riservata</div>
        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-6">
          <div>
            <label className="label-line" htmlFor="email">Email</label>
            <input id="email" data-testid="admin-login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="input-line" autoComplete="username" />
          </div>
          <div>
            <label className="label-line" htmlFor="password">Password</label>
            <input id="password" data-testid="admin-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="input-line" autoComplete="current-password" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-700">{error}</p>}
          <button type="submit" disabled={busy} data-testid="admin-login-submit" className="btn-primary w-full disabled:opacity-50">{busy ? "Accesso…" : "Accedi"}</button>
        </form>
        <a href="/" className="block mt-10 text-xs uppercase tracking-[0.18em] text-stone hover:text-gold">← Torna al sito</a>
      </div>
    </div>
  );
}
